import bigDealDays2026 from './assets/covers/bigDealDays2026.jpg';
import bigDealDaysLive2026 from './assets/covers/bigDealDaysLive2026.jpg';
import boostConversions from './assets/covers/boostConversions.jpg';
import buyBox from './assets/covers/buyBox.jpg';
import portStrike from './assets/covers/portStrike.jpg';
import primeBenefits from './assets/covers/primeBenefits.jpg';
import primeDayOver from './assets/covers/primeDayOver.jpg';
import primeDealDays from './assets/covers/primeDealDays.jpg';
import primeStartsNow from './assets/covers/primeStartsNow.jpg';
import tradeIn from './assets/covers/tradeIn.jpg';
import usingAi from './assets/covers/usingAi.jpg';
import warehouse from './assets/covers/warehouse.jpg';

/**
 * Cover photo shared by a post page and its home page card.
 * Photos are from Unsplash under the Unsplash License and must never show Amazon Marks.
 */
export interface Cover {
    src: string;
    alt: string;
}

export const bigDealDaysLive2026Cover: Cover = { src: bigDealDaysLive2026, alt: 'Red neon SALE sign in a shop window' };
export const bigDealDays2026Cover: Cover = { src: bigDealDays2026, alt: 'Calendar with red pins marking dates' };
export const primeDayOverCover: Cover = { src: primeDayOver, alt: 'Hand holding colorful shopping bags' };
export const primeStartsNowCover: Cover = { src: primeStartsNow, alt: 'Shopper holding a card at a laptop' };
export const primeDealDaysCover: Cover = { src: primeDealDays, alt: 'Alarm clock next to a desk calendar' };
export const portStrikeCover: Cover = { src: portStrike, alt: 'Container port with cranes at dusk' };
export const usingAiCover: Cover = { src: usingAi, alt: 'Circuit board pattern shaped like a brain' };
export const tradeInCover: Cover = { src: tradeIn, alt: 'Rows of old mobile phones' };
export const warehouseCover: Cover = { src: warehouse, alt: 'Warehouse shelves stocked with boxed goods' };
export const primeBenefitsCover: Cover = { src: primeBenefits, alt: 'Package delivered to a front door' };
export const buyBoxCover: Cover = { src: buyBox, alt: 'Online checkout screen with a shopping cart' };
export const boostConversionsCover: Cover = { src: boostConversions, alt: 'Analytics charts on a laptop screen' };
